import { DownloadOutlined } from "@ant-design/icons";
import { PDFDownloadLink } from "@react-pdf/renderer";
import React, { useEffect, useRef, useState } from "react";
import { certificate } from "../constants/utils";
import PDFDocument from "./PDFDocument";

function DownloadCertificatePdf({ certificateProp, autoDownload, onClick }) {
  const [certificateData, setCertificateData] = useState(certificate);
  const inputElement = useRef();
  useEffect(() => {
    const res = certificateProp;
    setCertificateData((prev) => ({
      ...prev,
      headerDescription: res?.header,
      headerNote: res?.important,
      contactDetails: {
        name: res?.contactInfo?.contactName,
        phone: res?.contactInfo?.phoneNumber,
        email: res?.contactInfo?.emailAddress,
        fax: res?.contactInfo?.fax,
      },
      producer: res?.producer,
      insured: res?.insured,
      policyText: res?.description,
      coverages: res?.coverages,
      certificateNumber: res?.certificateNumber,
      revisionNumber: res?.revisionNumber,
      insurer: {
        type: "INSURER(S) AFFORDING COVERAGE ",
        a: {
          title: res?.insuredList?.insuredA,
          value: res?.insuredList?.Naic_A,
        },
        b: {
          title: res?.insuredList?.insuredB,
          value: res?.insuredList?.Naic_B,
        },
        c: {
          title: res?.insuredList?.insuredC,
          value: res?.insuredList?.Naic_C,
        },
        d: {
          title: res?.insuredList?.insuredD,
          value: res?.insuredList?.Naic_D,
        },
        e: {
          title: res?.insuredList?.insuredE,
          value: res?.insuredList?.Naic_E,
        },
        f: {
          title: res?.insuredList?.insuredF,
          value: res?.insuredList?.Naic_F,
        },
      },
      generalLiability: {
        comLiab: res?.commercialGeneralLiability?.comLiab,
        policyNumber: res?.commercialGeneralLiability?.policyNumber,
        eef: res?.commercialGeneralLiability?.policyEFF,
        exp: res?.commercialGeneralLiability?.policyEXP,
        addlinsd: res?.commercialGeneralLiability?.addlinsd,
        subrwvd: res?.commercialGeneralLiability?.subrwvd,
        insurer: res?.commercialGeneralLiability?.insurer,

        limits: {
          eachOccurence: res?.commercialGeneralLiability?.eachOccurance || 123,
          damageToRentend: res?.commercialGeneralLiability?.damageToRented,
          medExp: res?.commercialGeneralLiability?.MEDEXP,
          advInjury: res?.commercialGeneralLiability?.personalAdvInjury,
          aggregate: res?.commercialGeneralLiability?.generalAggregate,
          products: res?.commercialGeneralLiability?.productsCompOpAgg,
          additionalCoverage:
            res?.commercialGeneralLiability?.additionalCoverage,
          additionalLimit: res?.commercialGeneralLiability?.additionalLimit,
        },
        aggegrateLimit: {
          policy: res?.commercialGeneralLiability?.policy,
          project: res?.commercialGeneralLiability?.project,
          loc: res?.commercialGeneralLiability?.loc,
          other: res?.commercialGeneralLiability?.genAggrLimitAppliedPer?.other,
        },
        claimsMade: res?.commercialGeneralLiability?.claimsMade,
        occur: res?.commercialGeneralLiability?.occur,
      },
      automobilityLiability: {
        anyAuto: res?.automobileLiability?.anyAutos,
        ownedAutosOnly: res?.automobileLiability?.ownedAutosOnly,
        scheduledAutos: res?.automobileLiability?.scheduledAutos,
        nonAwonedAutos: res?.automobileLiability?.nonOwnedAutosOnly,
        hiredAutosOnly: res?.automobileLiability?.hiredAutosOnly,
        policyNumber: res?.automobileLiability?.policyNumber,
        eef: res?.automobileLiability?.policyEFF,
        exp: res?.automobileLiability?.policyEXP,
        insurer: res?.automobileLiability?.insurer,
        limits: {
          combineSingleLimit: res?.automobileLiability?.combinedSingleLimit,
          bodilyInjuryPerPerson: res?.automobileLiability?.bodilyInjuryPerson,
          bodilyInuryPerAccident:
            res?.automobileLiability?.bodilyInjuryAccident,
          propertyDamage: res?.automobileLiability?.propertyDamage,
          additionalCoverage: res?.automobileLiability?.additionalCoverage,
          additionalLimit: res?.automobileLiability?.additionalLimit,
        },
      },
      general: {
        occcur: res?.umbrellaExcessLiability?.occur,
        umbrellaLiab: res?.umbrellaExcessLiability?.umbrellaLiab,
        excessLiab: res?.umbrellaExcessLiability?.excessLiab, 
        claimsMade: res?.umbrellaExcessLiability?.claimsMade,
        ded: res?.umbrellaExcessLiability?.ded,
        retentions: res?.umbrellaExcessLiability?.retentions,
        policyNumber: res?.umbrellaExcessLiability?.policyNumber,
        eff: res?.umbrellaExcessLiability?.policyEFF,
        exp: res?.umbrellaExcessLiability?.policyEXP,
        insurer: res?.umbrellaExcessLiability?.insurer,
        addlinsd: res?.umbrellaExcessLiability?.addlinsd,
        subrwvd: res?.umbrellaExcessLiability?.subrwvd,
        limits: {
          eachOccurence: res?.umbrellaExcessLiability?.eachOccurance,
          aggregate: res?.umbrellaExcessLiability?.aggregate,
          additionalCoverage: res?.umbrellaExcessLiability?.additionalCoverage,
          additionalLimit: res?.umbrellaExcessLiability?.additionalLimit,
        },
      },

      workers: {
        executive: res?.workersCompAndEmpLiability?.status === "Yes",
        policyNumber: res?.workersCompAndEmpLiability?.policyNumber,
        eff: res?.workersCompAndEmpLiability?.policyEFF,
        exp: res?.workersCompAndEmpLiability?.policyEXP,
        addlinsd: res?.workersCompAndEmpLiability?.addlinsd,
        subrwvd: res?.workersCompAndEmpLiability?.subrwvd,
        insurer: res?.workersCompAndEmpLiability?.insurer,
        limits: {
          perstatue: res?.workersCompAndEmpLiability?.perStatuteOther,
          eachAccident: res?.workersCompAndEmpLiability?.ELEachAccident,
          diseaseEaEmployee: res?.workersCompAndEmpLiability?.ELDiseaseEmp,
          diseasePolicyLimit:
            res?.workersCompAndEmpLiability?.ELDiseasePolicyLimit,
        },
      },
      physicalDamage: {
        policyNumber: res?.autoPhysicalDamage?.policyNumber,
        eef: res?.autoPhysicalDamage?.policyEFF,
        exp: res?.autoPhysicalDamage?.policyEXP,
        addlinsd: res?.autoPhysicalDamage?.addlinsd,
        subrwvd: res?.autoPhysicalDamage?.subrwvd,
        limit: res?.autoPhysicalDamage?.limit,
        insurer: res?.autoPhysicalDamage?.insurer,
      },
      motorTruckCargo: {
        limit: res?.motorTruckCargo?.limit,
        policyNumber: res?.motorTruckCargo?.policyNumber,
        addlinsd: res?.motorTruckCargo?.addlinsd,
        subrwvd: res?.motorTruckCargo?.subrwvd,
        eef: res?.motorTruckCargo?.policyEFF,
        exp: res?.motorTruckCargo?.policyEXP,
        insurer: res?.motorTruckCargo?.insurer,
      },

      certificateFooter: {
        description: res?.certificateFooter?.description,
        cancellation: res?.certificateFooter?.cancellation,
        certificateHolder: res?.certificateFooter?.certificateHolder,
      },
      signatureImage: res?.certificateFooter?.authorizedRepresentative,
    }));
  }, []);

  return (
    <PDFDownloadLink
      document={<PDFDocument certificate={certificateData} />}
      fileName="certificate.pdf"
      onClick={onClick}
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          <DownloadOutlined className="mt-1" style={{ color: "white" }} />
        ) : (
          <div>
            <DownloadOutlined
              ref={inputElement}
              className="mt-1"
              style={{ color: "white" }}
            />
            {autoDownload && inputElement?.current?.click() && window.close()}
          </div>
        )
      }
    </PDFDownloadLink>
  );
}

export default DownloadCertificatePdf;
